/** @jsx jsx */
import { FC, Fragment } from 'react'
import { jsx, Flex, Text, Link } from 'theme-ui'
import { graphql, useStaticQuery } from 'gatsby'

import { space } from '~/gatsby-plugin-theme-ui'

import useMediaQuery from '~/hooks/use-media-query'

type QueryResult = {
  data: {
    text: string
    textMobile: string
    link: string
    enabled: boolean
    allCaps: boolean
    theme: `light` | `dark`
  }
}

const query = graphql`
  query {
    data: settingsJson(templateKey: { eq: "top-banner" }) {
      text
      textMobile
      link
      enabled
      allCaps
      theme
    }
  }
`

type Props = {}

const TopBanner: FC<Props> = () => {
  const {
    data: { text, textMobile, enabled, link, allCaps, theme = 'light' },
  } = useStaticQuery<QueryResult>(query)

  const isMobile = useMediaQuery({
    query: breakpoints => `(max-width: ${breakpoints[2]})`,
  })

  if (!enabled) {
    return null
  }

  const hasLink = String(link).length > 0
  const isHtml = String(text).includes('<')

  const themeColors = {
    light: {
      bg: `dark`,
      color: `text`,
    },
    dark: {
      bg: `bgDarkBlue`,
      color: `main`,
    },
  }

  return (
    <Flex
      id="top-banner"
      sx={{
        position: 'relative',
        zIndex: 'header',
        bottom: '100%',
        width: `100%`,
        p: [space.sm * 1.5],
        alignItems: `center`,
        justifyContent: `center`,
        textAlign: `center`,
        bg: themeColors[theme].bg,
        display: 'block',
      }}
    >
      {isHtml ? (
        <Text
          as="span"
          sx={{
            color: themeColors[theme].color,
            fontSize: [2],
            textTransform: allCaps ? `uppercase` : `none`,
            a: {
              color: themeColors[theme].color,
              textDecoration: `underline`,
            },
          }}
          dangerouslySetInnerHTML={{ __html: isMobile ? textMobile : text }}
        />
      ) : (
        <Fragment>
          {hasLink ? (
            <Link
              variant="nav"
              href={link}
              sx={{
                color: themeColors[theme].color,
                fontSize: [2],
                textTransform: allCaps ? `uppercase` : `none`,
              }}
            >
              {text}
            </Link>
          ) : (
            <Text
              as="span"
              sx={{
                color: themeColors[theme].color,
                fontSize: [2],
                textTransform: allCaps ? `uppercase` : `none`,
              }}
            >
              {text}
            </Text>
          )}
        </Fragment>
      )}
    </Flex>
  )
}

export default TopBanner
